import { kebabCase } from 'lodash-es';

import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
	name: 'bpKebabCase',
})
export class KebabCasePipe implements PipeTransform {
	transform(value?: string): string {
		return kebabCase(value);
	}
}
